export default __webpack_public_path__ + "scene3_1_bgd1c06f.png";